import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";

import Header from "./common/Header";
import ManagerDetails from "./common/ManagerDetails";
import styles from "./styles/ResidentForm.module.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Button } from "react-bootstrap";
import { dialCodeMap } from "./common/constant";
import { Link, useNavigate, useParams, useSearchParams, generatePath } from "react-router-dom";

import http from "../api/server";
import {
  SUBMIT_RESIDENT_FORM_API,
  GET_RMS_MGMT_INFO,
  DOWNLOAD_TEMPLATE_API,
  GET_USER_CLIENT,
  GET_RMS_PROPERTIES,
  GET_CITY,
  GET_RMS_PROPERTY_DETAILS,
} from "../api/apiPath";

const FORMDATA = {
  firstName: "",
  middleName: "",
  lastName: "",
  primaryEmail: "",
  alternateEmail: "",
  mobileNumber: "", // default to a valid UK mobile number format
  mobileCountryCode: "gb", // default to UK
  alternateNumber: "",
  propertyAddress: "",
  apartmentNumber: "",
  propertyName: "",
  secondaryAddress: "",
  cityId: "",
  cityName: "",
  postCode: "",
  postCodeInfo: "", // Add this field to formData if usin
  residentCategory: "",
};

const MANAGERDATA = {
  Name: "",
  primaryEmail: "",
  mobileNumber: "", // default to a valid UK mobile number format
  dialCode: "",
  mobileCountryCode: "gb", // default to UK
};

const ResidentForm = () => {
  const navigate = useNavigate();
  const { userObj } = useSelector((state) => state.user);
  const [formData, setFormData] = useState(FORMDATA);
  const [errors, setErrors] = useState(FORMDATA);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { clientName } = useParams();
  const [searchParams] = useSearchParams();

  const [clientData, setClientData] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState({
    show: false,
    message: "",
    header: "",
  });
  const [showBulkDropdown, setShowBulkDropdown] = useState(false);
  const [showUserAccount, setShowUserAccount] = useState(false);
  const [error, setError] = useState(null);
  const [managerData, setManagerData] = useState({
    ...MANAGERDATA,
    primaryEmail: userObj?.userEmail,
  });
  const [managerDataEmpty, setManagerDataEmpty] = useState(false);
  const [properties, setProperties] = useState([]);
  const [isCustomProperty, setIsCustomProperty] = useState(false);
  const [cities, setCities] = useState([]);
  const [cityFromQueryParam, setCityFromQueryParam] = useState(null);

  const [reloadmanager, setReloadmanager] = useState(false);
  const handleDownloadTemplate = async () => {
    try {
      // close dropdown so UI feels snappy
      setShowBulkDropdown(false);

      const res = await http.get(DOWNLOAD_TEMPLATE_API, {
        responseType: "blob",
      });

      // figure out filename from Content-Disposition if present
      const cd = res.headers?.["content-disposition"] || "";
      let fileName = "Bulk_Resident_Upload_Template.xlsx";
      const match = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(cd);
      if (match) fileName = decodeURIComponent(match[1] || match[2]);

      const blob = new Blob([res.data], {
        type:
          res.headers?.["content-type"] ||
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed:", err);
      // optional: show a toast or inline error
      alert("Could not download template. Please try again.");
    }
  };

  const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  const emailRegex =
    /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"[^"]+")@(?:(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})$/;
  const ukPostcodeRegex = /^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2})$/i;

  useEffect(() => {
    const fetchData = async () => {
      if (userObj && !showUserAccount) {
        try {
          const mgmtResponse = await http.get(
            GET_RMS_MGMT_INFO + `?email=${userObj?.userEmail}`,
          );
          if (!mgmtResponse.status) {
            throw new Error(`HTTP error! status: ${mgmtResponse?.status}`);
          } else {
            const phoneArr = mgmtResponse?.data?.phone.split("-") || [];
            const detectedCountry = getCountryCodeFromPhone(phoneArr[0]);
            console.log("m", phoneArr, detectedCountry);
            setManagerData({
              ...managerData,
              Name: mgmtResponse?.data?.buildingManagedBy,
              mobileNumber: mgmtResponse?.data?.phone.replace(/-/g, ""),
              mobileCountryCode: detectedCountry,
              dialCode:
                phoneArr.length > 0 ? phoneArr[0].replace(/^\+/, "") : "+44",
            });
            setManagerDataEmpty(false);
          }
        } catch (error) {
          if (
            error.status === 404 &&
            error.data === "No record found with Email: " + userObj?.userEmail
          ) {
            setShowUserAccount(true);
            setManagerDataEmpty(true);
          } else {
            throw new Error(`HTTP error! status: ${error}`);
          }
        }
      }
    };

    fetchData();
  }, [userObj, reloadmanager]);

  useEffect(() => {
    const clients = clientData?.clients;
    if (!clients?.length) return;

    const matchedClient = clientName
      ? clients.find(
          (c) =>
            String(c.clientName || "").toLowerCase() ===
            String(clientName || "").toLowerCase()
        )
      : null;
    const client = matchedClient || clients[0];
    const clientId = client?.clientId;
    if (!clientId) return;

    const fetchCities = async () => {
      try {
        const response = await http.get(GET_CITY, {
          params: { clientId },
        });

        const cityList = Array.isArray(response.data) ? response.data : [];
        setCities(cityList);
      } catch (error) {
        console.error(
          "Error fetching cities:",
          error.response?.data || error.message,
        );
      }
    };

    fetchCities();
  }, [clientData, clientName]);

  const getCountryCodeFromPhone = (phone) => {
    for (const dial in dialCodeMap) {
      if (phone.startsWith(dial)) {
        return dialCodeMap[dial];
      }
    }
    return "gb"; // fallback
  };
  const isPropertyAlreadyExists = (name) => {
    if (!name) return false;

    return properties.some(
      (p) => p.name.trim().toLowerCase() === name.trim().toLowerCase(),
    );
  };
  5;
  useEffect(() => {
    if (!userObj?.userEmail) return;

    const fetchClients = async () => {
      try {
        const response = await http.get(GET_USER_CLIENT, {
          params: {
            userEmail: userObj.userEmail,
          },
        });

        console.log("Client data:", response.data);
        setClientData(response.data);
        console.log("Client id :- ", response.data);
      } catch (error) {
        console.error(
          "Error fetching clients:",
          error.response?.data || error.message,
        );
      }
    };

    fetchClients();
  }, [userObj?.userEmail]);

  useEffect(() => {
    const clients = clientData?.clients;
    if (!clients?.length) return;

    const matchedClient = clientName
      ? clients.find(
          (c) =>
            String(c.clientName || "").toLowerCase() ===
            String(clientName || "").toLowerCase()
        )
      : null;
    const client = matchedClient || clients[0];
    const clientId = client?.clientId;
    if (!clientId) return;

    const fetchProperties = async () => {
      try {
        const response = await http.get(GET_RMS_PROPERTIES, {
          params: { clientId },
        });

        const list = Array.isArray(response.data) ? response.data : [];
        const propertymasterId = searchParams.get("propertymasterID");
        if (propertymasterId) {
          setProperties((prev) => {
            const fromQuery = prev.filter((p) => p.fromQueryParam);
            return [...fromQuery, ...list];
          });
        } else {
          setProperties(list);
        }
      } catch (error) {
        console.error(
          "Error fetching properties:",
          error.response?.data || error.message,
        );
      }
    };

    fetchProperties();
  }, [clientData, clientName, searchParams]);

  useEffect(() => {
    const propertymasterId = searchParams.get("propertymasterID");

    if (!propertymasterId) {
      setCityFromQueryParam(null);
      setIsCustomProperty(false);
      return;
    }

    const fetchPropertyDetails = async () => {
      try {
        const response = await http.get(GET_RMS_PROPERTY_DETAILS, {
          params: { propertymasterID: propertymasterId },
        });

        const raw = response.data;
        const propertyData = raw?.data ?? raw;

        if (!propertyData || typeof propertyData !== "object") {
          return;
        }

        const name = propertyData.name ?? "";
        const address = propertyData.address ?? "";
        const postalCode = propertyData.postalCode ?? "";
        const city = propertyData.city ?? "";
        const cityIdFromApi = propertyData.cityId != null ? Number(propertyData.cityId) : "";

        const propertyForList = {
          propertyMasterId: propertyData.propertyMasterId ?? propertymasterId,
          name,
          address,
          city,
          postalCode,
          fromQueryParam: true,
        };

        setProperties((prev) => {
          const exists = prev.some(
            (p) =>
              (p.propertyMasterId && p.propertyMasterId === propertyForList.propertyMasterId) ||
              (p.name && p.name === name)
          );
          if (exists) return prev;
          return [propertyForList, ...prev];
        });

        setCityFromQueryParam(city || null);

        setFormData((prev) => ({
          ...prev,
          propertyName: name,
          propertyAddress: address,
          postCode: postalCode,
          cityName: city,
          cityId: cityIdFromApi,
          apartmentNumber: "",
          secondaryAddress: "",
        }));

        setIsCustomProperty(false);

        if (postalCode) {
          fetchPostCodeInfo(postalCode);
        }
      } catch (error) {
        console.error(
          "Error fetching property details:",
          error.response?.data || error.message,
        );
      }
    };

    fetchPropertyDetails();
  }, [searchParams]);

  useEffect(() => {
    if (cityFromQueryParam || cities.length === 0) {
      return;
    }

    setFormData((prev) => {
      const currentCityName = prev.cityName;

      if (!currentCityName || prev.cityId) {
        return prev;
      }

      const matchedCity = cities.find(
        (c) => String(c.cityName).trim() === String(currentCityName).trim()
      );

      if (matchedCity) {
        return {
          ...prev,
          cityId: matchedCity.cityId,
          cityName: matchedCity.cityName,
        };
      }

      return prev;
    });
  }, [cities, cityFromQueryParam]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Auto-format postcode
    let formattedValue = value;
    if (name === "postCode") {
      formattedValue = value.toUpperCase().replace(/\s+/g, "");
      if (formattedValue.length > 5) {
        formattedValue =
          formattedValue.slice(0, -3) + " " + formattedValue.slice(-3);
      }
    }
    setFormData({ ...formData, [name]: formattedValue });

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value ? "" : prevErrors[name],
    }));
  };

  const fetchPostCodeInfo = async (postcode) => {
    if (!postcode) return;
    try {
      const res = await fetch(`https://api.postcodes.io/postcodes/${postcode}`);
      const data = await res.json();
      if (data.status === 200) {
        setFormData((formData) => ({
          ...formData,
          postCodeInfo:
            (data.result.ced ? data.result.ced + ", " : "") +
            (data.result.pfa ? data.result.pfa + ", " : "") +
            data.result.country,
        }));
        setErrors((prev) => ({ ...prev, postCode: "" }));
      } else {
        setFormData((formData) => ({
          ...formData,
          postCodeInfo: "",
        }));
        setErrors((prev) => ({ ...prev, postCode: "Invalid UK Post Code" }));
      }
    } catch {
      setFormData((formData) => ({
        ...formData,
        postCodeInfo: "",
      }));
      setErrors((prev) => ({
        ...prev,
        postCode: "Failed to fetch postcode details",
      }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!emailRegex.test(formData.primaryEmail) && formData.primaryEmail)
      newErrors.primaryEmail = "Please enter valid Email Address";
    if (!emailRegex.test(formData.alternateEmail) && formData.alternateEmail)
      newErrors.alternateEmail = "Please enter valid Email Address";
    if (!formData.propertyAddress)
      newErrors.propertyAddress = "Property Address is required";
    if (!formData.apartmentNumber)
      newErrors.apartmentNumber = "Apartment/Flat/House Number is required";
    // if (!formData.propertyName)
    //   newErrors.propertyName = "Property Name is required";
    if (!formData.propertyName) {
      newErrors.propertyName = "Property Name is required";
    } else if (
      isCustomProperty &&
      isPropertyAlreadyExists(formData.propertyName)
    ) {
      newErrors.propertyName = "Property already exists";
    }

    // if (!formData.cityName) newErrors.cityName = "City Name is required";
    if (!formData.cityId) newErrors.cityId = "City is required";

    if (!formData.residentCategory)
      newErrors.residentCategory = "Resident Category is required";
    if (!formData.postCode) {
      newErrors.postCode = "Post Code is required";
    } else if (!ukPostcodeRegex.test(formData.postCode.trim())) {
      newErrors.postCode = "Invalid UK Post Code";
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      console.log("Form submitting...", formData);
      setIsSubmitting(true);
      try {
        const payload = {
          firstName: formData?.firstName || "",
          middleName: formData?.middleName || "",
          lastName: formData?.lastName || "",
          email: formData?.primaryEmail || "",
          alternateEmail: formData?.alternateEmail || "",
          phoneNumber: formData?.mobileNumber || "",
          alternateContactNumber: formData?.alternateNumber || "",
          propertyName: formData?.propertyName || "",
          propertyAddress: formData?.propertyAddress || "",
          apartmentOrHouseNo: formData?.apartmentNumber || "",
          // city: formData?.cityName || "",
          //  cityId: formData.cityId,
          // city: formData.cityName,
          city: String(formData.cityId),
          postCode: formData?.postCode || "",
          secondaryAddress: formData?.secondaryAddress || "",
          loggedInUserEmail: userObj?.userEmail,
          category: formData?.residentCategory || "",
        };

        await submitFormData(JSON.stringify(payload));
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const submitFormData = async (payload) => {
    try {
      const response = await http.post(SUBMIT_RESIDENT_FORM_API, payload);
      if (response.status === 200) {
        setShowConfirmation({
          show: true,
          header: "Form Submitted!",
          message: "Resident details submitted successfully!",
        });
      } else {
        setShowConfirmation({
          show: true,
          header: "Form Not Submitted!",
          message:
            "Resident details were not submitted successfully, please try again.",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setError(error);
    }
  };

  const handleReset = () => {
    setFormData(FORMDATA);
    setErrors(FORMDATA);
    setIsSubmitting(false);
    setShowConfirmation({ show: false, message: "", header: "" });
  };
  const handleNewResident = () => {
    setFormData({
      ...formData,
      firstName: "",
      lastName: "",
      middleName: "",
      mobileNumber: "",
      mobileCountryCode: "gb",
      primaryEmail: "",
      alternateEmail: "",
      apartmentNumber: "",
      alternateNumber: "",
    });
    setErrors(FORMDATA);
    setIsSubmitting(false);
    setShowConfirmation({ show: false, message: "", header: "" });
  };

  if (error)
    return (
      <>
        <div className="inCenterDiv">
          <i className="bi bi-exclamation-triangle red"></i>
          <h3>Something went wrong!</h3>
          <p>{error?.message}</p>
          <div className="col-sm-12 mb-4 text-center">
            <Link to="/">Go back to Login</Link>
          </div>
        </div>
      </>
    );

  return (
    <>
      <div>
        <Header
          setShowUserAccount={setShowUserAccount}
          showUserAccount={showUserAccount}
        />
      </div>
      {userObj && (
        <div className="dashboard_body_main vh-100">
          {showUserAccount && (
            <ManagerDetails
              managerData={managerData}
              onCancel={() => {
                setShowUserAccount((prev) => !prev);
              }}
              setReloadmanager={setReloadmanager}
            />
          )}
          <div className="d-flex dashboard_body flex-column py-3 px-5 w-100">
            <div className="row m-0 mb-2 section-header-outer">
              <h2 className="px-0">Personal Information</h2>
              <div className={`dropdown${showBulkDropdown ? " active" : ""}`}>
                <button
                  type="button"
                  className="btn btn-bulk-data"
                  id="bulkDataBtn"
                  onClick={() => setShowBulkDropdown((prev) => !prev)}
                >
                  Bulk Data
                  <i className="fa fa-solid fa-angle-down dropdown-arrow"></i>
                </button>
                {showBulkDropdown && (
                  <div className="dropdown-menu" id="dropdownMenu">
                    <div
                      className="dropdown-item"
                      onClick={handleDownloadTemplate}
                      role="button"
                    >
                      <i
                        className="fa fa-solid fa-file dropdown-icon"
                        style={{ color: "black" }}
                      ></i>
                      Download Template
                    </div>
                    <div
                      className="dropdown-item"
                      onClick={() => {
                        setShowBulkDropdown(false);
                        navigate(
                          generatePath("/client/:clientName/bulk-upload", {
                            clientName,
                          }),
                        );
                      }}
                    >
                      <i
                        className="fa fa-solid fa-arrow-up-from-bracket dropdown-icon"
                        style={{ color: "black" }}
                      ></i>
                      Upload Data
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="resident-card px-2 pt-3 pb-4 mb-4">
              <div className="card-body-section px-3">
                <div className="form-group">
                  <label htmlFor="firstName">First Name</label>
                  <input
                    className="form-control"
                    id="firstName"
                    type="text"
                    placeholder="Enter first name"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="middleName">Middle Name</label>
                  <input
                    type="text"
                    name="middleName"
                    className="form-control"
                    placeholder="Enter middle name"
                    id="middleName"
                    value={formData.middleName}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="lastName">Last Name</label>
                  <input
                    className="form-control"
                    placeholder="Enter last name"
                    id="lastName"
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group react-tel-input">
                  <label htmlFor="phoneNumber">Phone Number</label>
                  <PhoneInput
                    country={formData.mobileCountryCode}
                    value={formData.mobileNumber}
                    onChange={(phone, data) => {
                      console.log("pp", phone, data);
                      if (!phone.startsWith("+")) phone = "+" + phone;

                      setFormData({
                        ...formData,
                        mobileNumber: phone,
                        mobileCountryCode:
                          data.countryCode || formData.mobileCountryCode, // set country code on change
                      });
                    }}
                    inputProps={{
                      name: "mobileNumber",
                      required: true,
                      id: "countryPhone",
                      className: "form-control react-tel-input",
                      style: {
                        width: "100% !important",
                        padding: "1rem 2.75rem",
                        minHeight:
                          "calc(2.5rem + calc(var(--bs-border-width) * 2))",
                        lineHeight: "1.25",
                        background: "#F9F9F9",
                      },
                    }}
                    containerClass="w-100"
                    inputClass="w-100 react-tel-input"
                    enableSearch
                    placeholder="Enter phone number"
                  />
                </div>
                <div className="form-group">
                  <label id="alternateNumber">Alternate Phone Number:</label>
                  <input
                    id="alternateNumber"
                    className="form-control"
                    pattern="^(?:0|\+44|0044)?(?:1\d{9}|2\d{9})$"
                    title="Enter a valid UK landline number"
                    placeholder="Enter alternate phone number"
                    type="text"
                    name="alternateNumber"
                    value={formData.alternateNumber}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="floatingEmail">Email Address</label>
                  <input
                    placeholder="Enter email address"
                    //disabled={wantToUpdate}
                    className="form-control"
                    id="floatingEmail"
                    type="email"
                    name="primaryEmail"
                    value={formData.primaryEmail}
                    onChange={handleChange}
                  />

                  <span className={styles.formError}>
                    {errors.primaryEmail}
                  </span>
                </div>
                <div className="form-group">
                  <label htmlFor="floatingEmail">
                    Alternate Email Address:
                  </label>
                  <input
                    placeholder="Enter alternate email address"
                    //disabled={wantToUpdate}
                    className="form-control"
                    id="floatingEmail"
                    type="email"
                    name="alternateEmail"
                    value={formData.alternateEmail}
                    onChange={handleChange}
                  />

                  <span className={styles.formError}>
                    {errors.alternateEmail}
                  </span>
                </div>
                <div className="form-group">
                  <label htmlFor="ResidentCategory">
                    Resident Category<span className="astrik">*</span>:
                  </label>
                  <select
                    className="form-select"
                    id="ResidentCategory"
                    name="residentCategory"
                    value={formData.residentCategory}
                    onChange={handleChange}
                  >
                    <option value="">Select Resident Category</option>
                    <option value="Tenant">Tenant</option>
                    <option value="Landlord">Landlord</option>
                    <option value="Property Manager">Property Manager</option>
                  </select>
                  {errors.residentCategory && (
                    <span className={styles.formError}>
                      {errors.residentCategory}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="row m-0 mb-2 section-header-outer">
              <h2 className="px-0">Property Information</h2>
            </div>

            <div className="resident-card px-2 pt-3 py-4">
              <div className="card-body-section px-3">
                <div className="form-group">
                  <label htmlFor="buildingName">
                    Property Name<span className="astrik">*</span>:
                  </label>
                  {/* <input
                    id="propertyName"
                    className="form-control"
                    //disabled={wantToUpdate}
                    placeholder="Enter property name"
                    type="text"
                    name="propertyName"
                    value={formData.propertyName}
                    onChange={handleChange}
                  />
                  {errors.propertyName && (
                    <span className={styles.formError}>
                      {errors.propertyName}
                    </span>
                  )} */}
                  {/* <select
                    id="propertyName"
                    className="form-select"
                    name="propertyName"
                    value={formData.propertyName}
                    onChange={(e) => {
                      const selectedProperty = properties.find(
                        (p) => p.name === e.target.value,
                      );

                      if (selectedProperty) {
                        setFormData((prev) => ({
                          ...prev,
                          propertyName: selectedProperty.name,
                          propertyAddress: selectedProperty.address,
                          cityName: selectedProperty.city,
                          postCode: selectedProperty.postalCode,
                        }));
                      }
                    }}
                  >
                    <option value="">Select Property</option>
                    {properties.map((property) => (
                      <option
                        key={property.propertyMasterId}
                        value={property.name}
                      >
                        {property.name}
                      </option>
                    ))}
                  </select> */}
                  {cityFromQueryParam ? (
                    <input
                      id="propertyName"
                      className="form-control"
                      type="text"
                      value={formData.propertyName}
                      readOnly
                      disabled
                      style={{ backgroundColor: "#e9ecef", cursor: "not-allowed" }}
                    />
                  ) : (
                    <select
                      id="propertyName"
                      className="form-select"
                      name="propertyName"
                      value={
                        isCustomProperty ? "__custom__" : formData.propertyName
                      }
                      onChange={(e) => {
                        const value = e.target.value;

                        if (value === "__custom__") {
                          setIsCustomProperty(true);
                          setFormData((prev) => ({
                            ...prev,
                            propertyName: "",
                            propertyAddress: "",
                            cityName: "",
                            postCode: "",
                          }));
                          return;
                        }

                        setIsCustomProperty(false);

                        const selectedProperty = properties.find(
                          (p) => p.name === value,
                        );

                        if (selectedProperty) {
                          const matchedCity = cities.find(
                            (c) => c.cityName === selectedProperty.city,
                          );

                          setFormData((prev) => ({
                            ...prev,
                            propertyName: selectedProperty.name,
                            propertyAddress: selectedProperty.address,
                            cityName: selectedProperty.city,
                            cityId: matchedCity ? matchedCity.cityId : "",
                            postCode: selectedProperty.postalCode,
                          }));
                        }
                      }}
                    >
                      <option value="__custom__">+ Add New Property</option>
                      <option value="">Select Property</option>
                      {properties.map((property) => (
                        <option
                          key={property.propertyMasterId}
                          value={property.name}
                        >
                          {property.name}
                        </option>
                      ))}
                    </select>
                  )}
                  {!cityFromQueryParam && isCustomProperty && (
                    <div className="form-group mt-2">
                      <input
                        id="customPropertyName"
                        className="form-control"
                        placeholder="Enter property name"
                        type="text"
                        value={formData.propertyName}
                        onChange={(e) => {
                          const value = e.target.value;

                          setFormData((prev) => ({
                            ...prev,
                            propertyName: value,
                          }));

                          // duplicate check
                          if (isPropertyAlreadyExists(value)) {
                            setErrors((prev) => ({
                              ...prev,
                              propertyName: "Property already exists",
                            }));
                          } else {
                            setErrors((prev) => ({
                              ...prev,
                              propertyName: "",
                            }));
                          }
                        }}
                      />
                    </div>
                  )}

                  {errors.propertyName && (
                    <span className={styles.formError}>
                      {errors.propertyName}
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="propertyAddress">
                    Property Address<span className="astrik">*</span>:
                  </label>
                  <input
                    id="propertyAddress"
                    className="form-control"
                    placeholder="Enter property address"
                    type="text"
                    name="propertyAddress"
                    value={formData.propertyAddress}
                    onChange={handleChange}
                    readOnly={!!cityFromQueryParam}
                    disabled={!!cityFromQueryParam}
                    style={cityFromQueryParam ? { backgroundColor: "#e9ecef", cursor: "not-allowed" } : undefined}
                  />
                  {errors.propertyAddress && (
                    <span className={styles.formError}>
                      {errors.propertyAddress}
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="address" className={styles.formLabel}>
                    Secondary Address:
                  </label>
                  <textarea
                    id="secondaryaddress"
                    placeholder="Enter secondary address"
                    className="form-control"
                    rows={2}
                    name="secondaryAddress"
                    value={formData.secondaryAddress}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="apartmentNumber">
                    {isMobile
                      ? "Apt/Flat/House No."
                      : "Apartment / Flat / House Number"}
                    <span className="astrik">*</span>:
                  </label>
                  <input
                    id="apartmentNumber"
                    className="form-control"
                    placeholder={
                      isMobile
                        ? "Enter apt/flat/house no."
                        : "Enter apartment/flat/house number address"
                    }
                    type="text"
                    name="apartmentNumber"
                    value={formData.apartmentNumber}
                    onChange={handleChange}
                  />
                  {errors.apartmentNumber && (
                    <span className={styles.formError}>
                      {errors.apartmentNumber}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="cityName">
                    City Name<span className="astrik">*</span>:
                  </label>
                  {cityFromQueryParam ? (
                    <input
                      id="cityId"
                      className="form-control"
                      type="text"
                      value={formData.cityName || cityFromQueryParam}
                      readOnly
                      disabled
                      style={{ backgroundColor: "#e9ecef", cursor: "not-allowed" }}
                    />
                  ) : (
                    <select
                      id="cityId"
                      className="form-select"
                      name="cityId"
                      value={formData.cityId || ""}
                      onChange={(e) => {
                        const selectedId = Number(e.target.value);

                        const selectedCity = cities.find(
                          (c) => c.cityId === selectedId,
                        );

                        setFormData((prev) => ({
                          ...prev,
                          cityId: selectedId,
                          cityName: selectedCity?.cityName || "",
                        }));

                        setErrors((prev) => ({
                          ...prev,
                          cityId: "",
                        }));
                      }}
                    >
                      <option value="">Select City</option>

                      {cities.map((city) => (
                        <option key={city.cityId} value={city.cityId}>
                          {city.cityName}
                        </option>
                      ))}
                    </select>
                  )}

                  {errors.cityId && (
                    <span className={styles.formError}>{errors.cityId}</span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="postCode">
                    Post Code<span className="astrik">*</span>:
                  </label>
                  <input
                    id="postCode"
                    className="form-control"
                    placeholder="Enter post code"
                    type="text"
                    name="postCode"
                    value={formData.postCode}
                    onChange={(e) => {
                      handleChange(e);
                      fetchPostCodeInfo(e.target.value);
                    }}
                    onBlur={(e) => fetchPostCodeInfo(e.target.value)}
                    readOnly={!!cityFromQueryParam}
                    disabled={!!cityFromQueryParam}
                    style={cityFromQueryParam ? { backgroundColor: "#e9ecef", cursor: "not-allowed" } : undefined}
                  />

                  {errors.postCode && (
                    <span className={styles.formError}>{errors.postCode}</span>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="postcodeInfo">Post Code Address:</label>
                  <input
                    id="postcodeInfo"
                    className="form-control"
                    placeholder=""
                    type="text"
                    name="postcodeInfo"
                    value={formData.postCodeInfo}
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>

          {managerDataEmpty && (
            <span className={styles.submitError + " px-5 pb-1"}>
              <i
                className="fa fa-solid fa-circle-info"
                title="Edit Account Details"
              ></i>{" "}
              Please complete your profile before managing resident details. You
              can access it by clicking the{" "}
              <i
                className="fa fa-solid fa-gear"
                title="Edit Account Details"
              ></i>{" "}
              icon above.
            </span>
          )}
          <div className="px-5 pb-3 button-group">
            <Button
              type="reset"
              className="btn btn-secondary"
              size="lg"
              variant="secondary"
              onClick={handleReset}
              style={{ width: "15%" }}
              disabled={isSubmitting}
            >
              Reset
            </Button>

            {/* // <button type="submit" className='btn-primary'>Submit</button> */}
            <Button
              variant="primary"
              size="lg"
              className="btn btn-primary"
              active
              type="submit"
              onClick={handleSubmit}
              style={{ width: "15%" }}
              disabled={isSubmitting || managerDataEmpty}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </Button>
          </div>

          {showConfirmation?.show && (
            <div className="service-card">
              <div className={styles.modalOverlay}>
                <div className={styles.modalContent}>
                  <h5>{showConfirmation?.header}</h5>
                  <p>{showConfirmation?.message}</p>
                  <div className="d-flex gap-2 justify-content-center">
                    <button
                      type="cancel"
                      className="btn btn-tertiary modal-button"
                      onClick={handleReset}
                    >
                      Close
                    </button>
                    <button
                      type="close"
                      className="btn btn-secondary modal-button"
                      onClick={handleNewResident}
                    >
                      Add New Resident
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};
export default ResidentForm;
